import * as classNames from 'classnames';
import { IEditContact } from 'common/interfaces/contacts';
import { Checkbox } from 'components/action';
import { action, computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { IAppOnlyStore } from 'stores/AllStores';
import { EContactFieldName, IContactField } from './..';

// Styles
const s = require('./../LeadContacts.css');

// Props
interface ILeadContactEditOrCreateProps extends IAppOnlyStore {
  order?: number;
  textFields: IContactField[];
  contact: IEditContact;
}

// Component
@inject('store')
@observer
export class LeadContactEditOrCreate extends React.Component<
  ILeadContactEditOrCreateProps,
  {}
> {
  constructor(props: ILeadContactEditOrCreateProps) {
    super(props);
  }

  @computed private get isNew(): boolean {
    return this.props.contact.id === null ? true : false;
  }

  @computed private get editIndex(): number {
    return this.props.store.leadContacts.editedContactsIds.indexOf(
      this.props.contact.id
    );
  }

  public render() {
    const { contact } = this.props;

    return this.editIndex !== -1 ? (
      <div className={classNames(s.contact, s.contactBeingEdited)}>
        {(this.isNew && <h5>New contact:</h5>) || (
          <h5>
            Edit contact
            {typeof this.props.order !== 'undefined'
              ? ' #' + this.props.order
              : ''}
            :
          </h5>
        )}

        {this.props.textFields.map((field) => {
          return (
            <label key={`field-${field.name}`}>
              <p>
                <span>{field.label}</span>
              </p>
              <input
                type="text"
                name={field.name}
                value={contact[field.name] as string}
                onChange={this.handleFieldValueChange(field.name)}
              />
            </label>
          );
        })}

        <div>
          <br />
          <Checkbox
            className={s.primary}
            onChange={this.handleDefaultValueChange}
            checked={contact.default}
            value={true}
            valueUnchecked={false}
            label="Primary contact"
          />
        </div>
      </div>
    ) : null;
  }

  @action private handleFieldValueChange = (field: EContactFieldName) => (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    // @ts-ignore
    this.props.store.leadContacts.editedContacts[this.editIndex][field] =
      e.currentTarget.value;
    this.props.store.leadContacts.editedContacts[
      this.editIndex
    ].modified = true;
  };

  @action private handleDefaultValueChange = (
    checked: boolean,
    value: boolean
  ) => {
    if (this.props.contact.id !== null) {
      this.props.store.leadContacts.toggleDefaultContact(
        this.props.contact.id,
        checked
      );
    }
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/sales/Lead/Contacts/Contact/LeadContactEditOrCreate.tsx